import { DataSourcesQueries } from '@frontend/api-data-sources';

export const useGetWaitlistFeatureFlagDetails = () => {
  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  return {
    isLoading: isLoadingIntegrationDetails,
    isWaitlistDirectBookingEnabled: !isIntegratedOffice,
  };
};
